import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * FilterCategoriesView class extends JetView to create a filter form for categories.
 */
export default class FilterCategoriesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            // Left section of the form
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id', // Input for category ID
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                            labelPosition: 'top',
                            placeholder: _('ID'),
                        },
                        {
                            view: 'text',
                            name: 'Description', // Input for category description
                            label: "<span class='icon-file-text1'></span>" + _('Descripción'),
                            labelPosition: 'top',
                            placeholder: _('Descripción'),
                        },
                        {
                            view: 'richselect',
                            name: 'Type', // Dropdown for category type
                            label: _('Tipo'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: '1', value: _('Casino') },
                                { id: '2', value: _('LiveCasino') },
                            ],
                        },
                    ],
                },
            ],
        };

        const left2 = {
            // Second left section of the form
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Slug', // Input for category slug
                            label: _('Slug'),
                            labelPosition: 'top',
                            placeholder: _('Slug'),
                            invalidMessage: _('Slug is required'), // Validation message
                        },
                        {
                            view: 'richselect',
                            name: 'IsActivate', // Dropdown for activation status
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'text',
                            name: 'Higher', // Input for higher category
                            label: "<span class='icon-arrow-up'></span>" + _('Superior'),
                            labelPosition: 'top',
                            placeholder: _('Superior'),
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            // Upper section of the form
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 200 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        const upper_section2 = {
            // Second upper section of the form
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 200 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left2],
                },
            ],
        };

        const accordion_section = {
            // Accordion section for advanced filters
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'),
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };

        const buttons = {
            // Button section for actions
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 },
                        {
                            view: 'button',
                            value: _('Añadir Categoría'), // Button to add category
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            minWidth: 200,
                            hidden: !devConfig.getPermAction('categoriesAdd', 'Add'), // Permission check
                            css: 'prm-categoriesAdd',
                            click: () => {
                                this.app.callEvent('addCategorie:button', [[]]); // Event to add category
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Button to clear form
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form values
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Button to consult/filter categories
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('categories:filter', [filterdata]); // Event to filter categories
                                $$('b1').collapse(); // Collapse the filter section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section1 = {
            // Main accordion section for filters
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, accordion_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        return {
            // Return the main form configuration
            view: 'form',
            type: 'clean',
            rows: [accordion_section1],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object passed during initialization.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element if screen width is less than 500
            }
        });
    }
}

// FILE DOCUMENTED
